import { usePayableDetail } from "../../hooks/usePayableDetail";

const DetailOriginSection = () => {
  const { detail } = usePayableDetail();

  if (!detail?.origin) return null;

  const { origin } = detail;

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Origen de la Deuda
      </h4>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

        {/* Referencia origen */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Referencia
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.referenceNumber || "-"}
          </p>
        </div>

        {/* Documento */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Documento
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.documentNumber || "Sin documento"}
          </p>
        </div>

        {/* Tipo documento */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Tipo de documento
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.documentType || "-"}
          </p>
        </div>

        {/* Fecha origen */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Fecha de origen
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.issueDate || "-"}
          </p>
        </div>

        {/* Fuente */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Fuente
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.sourceName || "No disponible"}
          </p>
        </div>

        {/* Sucursal */}
        <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 dark:border-primary/30 dark:bg-primary/10">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Sucursal origen
          </p>

          <p className="font-semibold text-black dark:text-white">
            {origin.branchName || "No definida"}
          </p>
        </div>

      </div>
    </section>
  );
};

export default DetailOriginSection;